import type { SVGProps } from 'react'

import { Wrapper } from './Wrapper'

export const IconHeaderTime = (props: SVGProps<SVGSVGElement>) => (
	<Wrapper>
		<svg width='101' height='100' viewBox='0 0 101 100' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path
				d='M94.4191 52.16L61.6191 33.21L10.2991 62.84L2.36914 63.85V67.42L40.2591 89.28L99.4991 55.09V51.52L94.4191 52.16Z'
				fill='#0000FF'
			/>
			<mask id='mask0_7165_19775' maskUnits='userSpaceOnUse' x='2' y='33' width='98' height='57'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M94.4191 52.16L61.6191 33.21L10.2991 62.84L2.36914 63.85V67.42L40.2591 89.28L99.4991 55.09V51.52L94.4191 52.16Z'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_7165_19775)'>
				<rect x='-3.16992' y='27.6699' width='108.21' height='67.16' fill='#0000FF' />
			</g>
			<path d='M61.6191 29.6401L99.4991 51.5201L40.2591 85.7201L2.36914 63.8501L61.6191 29.6401Z' fill='#99CCFF' />
			<mask id='mask1_7165_19775' maskUnits='userSpaceOnUse' x='2' y='29' width='98' height='57'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M61.6191 29.6401L99.4991 51.5201L40.2591 85.7201L2.36914 63.8501L61.6191 29.6401Z'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask1_7165_19775)'>
				<rect x='-3.16992' y='24.1001' width='108.21' height='67.16' fill='#99CCFF' />
			</g>
			<mask id='mask2_7165_19775' maskUnits='userSpaceOnUse' x='14' y='37' width='71' height='42'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M41.179 78.7903L84.969 52.5503L59.729 37.7803L14.959 63.6303L41.179 78.7903Z'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask2_7165_19775)'>
				<rect opacity='0.1' x='9.4082' y='32.2402' width='81.09' height='52.09' fill='#00055A' />
			</g>
			<path
				d='M85.0384 51.6299L58.1284 35.8799L30.2884 51.8799C27.1115 53.7224 23.6002 54.9155 19.9584 55.3899L14.6484 56.1099L41.8284 71.8699L47.1484 71.1399C50.7969 70.6426 54.3129 69.4367 57.4984 67.5899L85.0384 51.6299Z'
				fill='#FDECE4'
			/>
			<mask id='mask3_7165_19775' maskUnits='userSpaceOnUse' x='14' y='35' width='72' height='37'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M85.0384 51.6299L58.1284 35.8799L30.2884 51.8799C27.1115 53.7224 23.6002 54.9155 19.9584 55.3899L14.6484 56.1099L41.8284 71.8699L47.1484 71.1399C50.7969 70.6426 54.3129 69.4367 57.4984 67.5899L85.0384 51.6299Z'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask3_7165_19775)'>
				<rect x='9.10938' y='30.3398' width='81.47' height='47.07' fill='#FDECE4' />
			</g>
			<path d='M72.94 51.9102L55.25 41.6902L56.59 40.9102L74.29 51.1302L72.94 51.9102Z' fill='#F0C1AE' />
			<mask id='mask4_7165_19775' maskUnits='userSpaceOnUse' x='55' y='40' width='20' height='12'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M72.94 51.9102L55.25 41.6902L56.59 40.9102L74.29 51.1302L72.94 51.9102Z'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask4_7165_19775)'>
				<rect x='49.7109' y='35.3701' width='30.13' height='22.08' fill='#F0C1AE' />
			</g>
			<path d='M64.2584 56.9199L46.5684 46.6999L47.9184 45.9199L65.6184 56.1399L64.2584 56.9199Z' fill='#0000A0' />
			<mask id='mask5_7165_19775' maskUnits='userSpaceOnUse' x='46' y='45' width='20' height='12'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M64.2584 56.9199L46.5684 46.6999L47.9184 45.9199L65.6184 56.1399L64.2584 56.9199Z'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask5_7165_19775)'>
				<rect x='41.0293' y='40.3799' width='30.13' height='22.08' fill='#F0C1AE' />
			</g>
			<path d='M46.1682 51.8504L41.9082 49.3904L43.2582 48.6104L47.5282 51.0704L46.1682 51.8504Z' fill='#F0C1AE' />
			<mask id='mask6_7165_19775' maskUnits='userSpaceOnUse' x='41' y='48' width='7' height='4'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M46.1682 51.8504L41.9082 49.3904L43.2582 48.6104L47.5282 51.0704L46.1682 51.8504Z'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask6_7165_19775)'>
				<rect x='36.3691' y='43.0703' width='16.7' height='14.32' fill='#F0C1AE' />
			</g>
			<path d='M59.5882 59.6002L48.9082 53.4402L50.2682 52.6602L60.9382 58.8202L59.5882 59.6002Z' fill='#F0C1AE' />
			<mask id='mask7_7165_19775' maskUnits='userSpaceOnUse' x='48' y='52' width='13' height='8'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M59.5882 59.6002L48.9082 53.4402L50.2682 52.6602L60.9382 58.8202L59.5882 59.6002Z'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask7_7165_19775)'>
				<rect x='43.3691' y='47.1201' width='23.11' height='18.02' fill='#F0C1AE' />
			</g>
			<path d='M47.4183 58.66L36.7383 52.49L38.0983 51.71L48.7683 57.88L47.4183 58.66Z' fill='#F0C1AE' />
			<mask id='mask8_7165_19775' maskUnits='userSpaceOnUse' x='36' y='51' width='13' height='8'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M47.4183 58.66L36.7383 52.49L38.0983 51.71L48.7683 57.88L47.4183 58.66Z'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask8_7165_19775)'>
				<rect x='31.1992' y='46.1699' width='23.11' height='18.02' fill='#F0C1AE' />
			</g>
			<path d='M61.4791 50.1603L51.0391 44.1203L52.3791 43.3403L62.8391 49.3803L61.4791 50.1603Z' fill='#F0C1AE' />
			<mask id='mask9_7165_19775' maskUnits='userSpaceOnUse' x='51' y='43' width='12' height='8'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M61.4791 50.1603L51.0391 44.1203L52.3791 43.3403L62.8391 49.3803L61.4791 50.1603Z'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask9_7165_19775)'>
				<rect x='45.5' y='37.8003' width='22.88' height='17.9' fill='#F0C1AE' />
			</g>
			<path d='M68.6483 54.3001L63.9883 51.6101L65.3483 50.8301L70.0083 53.5101L68.6483 54.3001Z' fill='#F0C1AE' />
			<mask id='mask10_7165_19775' maskUnits='userSpaceOnUse' x='63' y='50' width='8' height='5'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M68.6483 54.3001L63.9883 51.6101L65.3483 50.8301L70.0083 53.5101L68.6483 54.3001Z'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask10_7165_19775)'>
				<rect x='58.4492' y='45.2803' width='17.1' height='14.55' fill='#F0C1AE' />
			</g>
			<path
				d='M76.5485 39.7003V40.7803C76.5087 40.251 76.1769 39.7881 75.6885 39.5803C74.392 38.9309 72.8651 38.9309 71.5685 39.5803C71.0979 39.8006 70.7785 40.253 70.7285 40.7703V39.7703C70.7661 39.2485 71.0894 38.7904 71.5685 38.5803C72.8651 37.9309 74.392 37.9309 75.6885 38.5803C76.1475 38.7825 76.4717 39.2047 76.5485 39.7003Z'
				fill='#0000FF'
			/>
			<mask id='mask11_7165_19775' maskUnits='userSpaceOnUse' x='70' y='38' width='7' height='3'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M76.5485 39.7003V40.7803C76.5087 40.251 76.1769 39.7881 75.6885 39.5803C74.392 38.9309 72.8651 38.9309 71.5685 39.5803C71.0979 39.8006 70.7785 40.253 70.7285 40.7703V39.7703C70.7661 39.2485 71.0894 38.7904 71.5685 38.5803C72.8651 37.9309 74.392 37.9309 75.6885 38.5803C76.1475 38.7825 76.4717 39.2047 76.5485 39.7003Z'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask11_7165_19775)'>
				<rect x='65.1777' y='32.5303' width='16.91' height='13.79' fill='#0000FF' />
			</g>
			<path
				d='M79.1 39.7002V40.7802C79.0048 41.7541 78.3938 42.6019 77.5 43.0002V41.8702C78.3769 41.4774 78.984 40.654 79.1 39.7002Z'
				fill='#0000FF'
			/>
			<mask id='mask12_7165_19775' maskUnits='userSpaceOnUse' x='77' y='39' width='3' height='4'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M79.1 39.7002V40.7802C79.0048 41.7541 78.3938 42.6019 77.5 43.0002V41.8702C78.3769 41.4774 78.984 40.654 79.1 39.7002Z'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask12_7165_19775)'>
				<rect x='71.9102' y='34.1602' width='12.73' height='14.34' fill='#0000FF' />
			</g>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M81.9091 44.4701L77.4991 41.9201H77.4691C79.6391 40.6901 79.6391 38.6801 77.4691 37.4401C75.0345 36.2005 72.1538 36.2005 69.7191 37.4401L65.3091 34.8901L59.3691 38.3501L75.9691 47.9301L81.9091 44.4701ZM75.6991 40.8401C74.4053 41.5008 72.873 41.5008 71.5791 40.8401C71.0674 40.6624 70.723 40.1818 70.7191 39.6401C70.7212 39.1002 71.0671 38.6216 71.5791 38.4501C72.8757 37.8007 74.4026 37.8007 75.6991 38.4501C76.2131 38.622 76.5597 39.1032 76.5597 39.6451C76.5597 40.1871 76.2131 40.6683 75.6991 40.8401Z'
				fill='#3399FF'
			/>
			<mask id='mask13_7165_19775' maskUnits='userSpaceOnUse' x='59' y='34' width='23' height='14'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M71.5791 40.8401C72.873 41.5008 74.4053 41.5008 75.6991 40.8401C76.2131 40.6683 76.5597 40.1871 76.5597 39.6451C76.5597 39.1032 76.2131 38.622 75.6991 38.4501C74.4026 37.8007 72.8757 37.8007 71.5791 38.4501C71.0671 38.6216 70.7212 39.1002 70.7191 39.6401C70.723 40.1818 71.0674 40.6624 71.5791 40.8401ZM77.4991 41.9201L81.9091 44.4701L75.9691 47.9301L59.3691 38.3501L65.3091 34.8901L69.7191 37.4401C72.1538 36.2005 75.0345 36.2005 77.4691 37.4401C79.6391 38.6801 79.6391 40.6901 77.4691 41.9201H77.4991Z'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask13_7165_19775)'>
				<rect x='53.7695' y='29.3501' width='33.63' height='24.12' fill='#3399FF' />
			</g>
			<path d='M81.8599 44.4702V45.5002L75.9199 48.9602V47.9302L81.8599 44.4702Z' fill='#0000FF' />
			<mask id='mask14_7165_19775' maskUnits='userSpaceOnUse' x='75' y='44' width='7' height='5'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M81.8599 44.4702V45.5002L75.9199 48.9602V47.9302L81.8599 44.4702Z'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask14_7165_19775)'>
				<rect x='70.3809' y='38.9302' width='17.03' height='15.57' fill='#0000FF' />
			</g>
			<path d='M75.9198 47.9301V48.9601L59.3398 39.3801V38.3501L75.9198 47.9301Z' fill='#0000FF' />
			<mask id='mask15_7165_19775' maskUnits='userSpaceOnUse' x='59' y='38' width='17' height='11'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M75.9198 47.9301V48.9601L59.3398 39.3801V38.3501L75.9198 47.9301Z'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask15_7165_19775)'>
				<rect x='53.8008' y='32.8101' width='27.67' height='21.69' fill='#0000FF' />
			</g>
			<path
				d='M33.2782 42.76C44.5182 42.93 53.7182 37.45 53.8182 30.53L53.8882 24.4C53.8882 24.4 41.2382 17.81 33.6382 17.69C26.3382 17.58 13.2282 23.28 13.2282 23.28C13.2282 23.28 13.1082 29.78 13.1082 29.92C13.0082 36.84 22.0382 42.59 33.2782 42.76Z'
				fill='#0000FF'
			/>
			<mask id='mask16_7165_19775' maskUnits='userSpaceOnUse' x='13' y='17' width='41' height='26'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M33.2782 42.76C44.5182 42.93 53.7182 37.45 53.8182 30.53L53.8882 24.4C53.8882 24.4 41.2382 17.81 33.6382 17.69C26.3382 17.58 13.2282 23.28 13.2282 23.28C13.2282 23.28 13.1082 29.78 13.1082 29.92C13.0082 36.84 22.0382 42.59 33.2782 42.76Z'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask16_7165_19775)'>
				<rect x='7.56836' y='12.1499' width='51.86' height='36.15' fill='#0000FF' />
			</g>
			<path
				d='M48.1191 25.72C48.0802 26.9517 47.6571 28.1405 46.9091 29.12C48.6928 27.9953 49.8473 26.1007 50.0291 24C50.0991 19.1 42.8191 14.92 33.7591 14.76C30.2044 14.6538 26.6663 15.2872 23.3691 16.62C25.7748 16.0611 28.2398 15.7992 30.7091 15.84C40.4091 16 48.1991 20.43 48.1191 25.72Z'
				fill='#3399FF'
			/>
			<mask id='mask17_7165_19775' maskUnits='userSpaceOnUse' x='23' y='14' width='28' height='16'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M48.1191 25.72C48.0802 26.9517 47.6571 28.1405 46.9091 29.12C48.6928 27.9953 49.8473 26.1007 50.0291 24C50.0991 19.1 42.8191 14.92 33.7591 14.76C30.2044 14.6538 26.6663 15.2872 23.3691 16.62C25.7748 16.0611 28.2398 15.7992 30.7091 15.84C40.4091 16 48.1991 20.43 48.1191 25.72Z'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask17_7165_19775)'>
				<rect x='17.8301' y='9.18018' width='37.74' height='25.49' fill='#3399FF' />
			</g>
			<path
				d='M17.2799 23.55C17.1999 28.5 24.4799 32.62 33.5499 32.77C39.0599 32.84 43.9499 31.43 46.9499 29.19C47.6956 28.1847 48.1082 26.9714 48.1299 25.72C48.2099 20.41 40.42 15.95 30.78 15.86C28.3108 15.8104 25.8451 16.069 23.4399 16.63C19.67 18.23 17.2799 20.71 17.2799 23.55Z'
				fill='#99CCFF'
			/>
			<mask id='mask18_7165_19775' maskUnits='userSpaceOnUse' x='17' y='15' width='32' height='18'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M17.2799 23.55C17.1999 28.5 24.4799 32.62 33.5499 32.77C39.0599 32.84 43.9499 31.43 46.9499 29.19C47.6956 28.1847 48.1082 26.9714 48.1299 25.72C48.2099 20.41 40.42 15.95 30.78 15.86C28.3108 15.8104 25.8451 16.069 23.4399 16.63C19.67 18.23 17.2799 20.71 17.2799 23.55Z'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask18_7165_19775)'>
				<rect x='11.7305' y='10.3101' width='41.94' height='28' fill='#99CCFF' />
			</g>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M53.8898 24.4001C53.7798 31.3201 44.5998 36.7901 33.3598 36.6301C22.1198 36.4401 13.1098 30.6601 13.2098 23.7901C13.3098 16.9201 22.4898 11.5001 33.7298 11.6201C44.9698 11.7401 53.9998 17.4801 53.8898 24.4001ZM23.4198 16.6901C19.7098 18.2801 17.2798 20.7501 17.2798 23.5501C17.1698 28.4601 24.4998 32.5801 33.5498 32.6901C39.0198 32.7701 43.9498 31.3601 46.9498 29.1501C48.7438 28.0215 49.9001 26.1127 50.0698 24.0001C50.0698 19.0601 42.8098 14.9201 33.8098 14.7901C30.2526 14.701 26.7153 15.3479 23.4198 16.6901Z'
				fill='#E5F2FF'
			/>
			<mask id='mask19_7165_19775' maskUnits='userSpaceOnUse' x='13' y='11' width='41' height='26'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M17.2798 23.5501C17.2798 20.7501 19.7098 18.2801 23.4198 16.6901C26.7153 15.3479 30.2526 14.701 33.8098 14.7901C42.8098 14.9201 50.0698 19.0601 50.0698 24.0001C49.9001 26.1127 48.7438 28.0215 46.9498 29.1501C43.9498 31.3601 39.0198 32.7701 33.5498 32.6901C24.4998 32.5801 17.1698 28.4601 17.2798 23.5501ZM33.3598 36.6301C44.5998 36.7901 53.7798 31.3201 53.8898 24.4001C53.9998 17.4801 44.9698 11.7401 33.7298 11.6201C22.4898 11.5001 13.3098 16.9201 13.2098 23.7901C13.1098 30.6601 22.1198 36.4401 33.3598 36.6301Z'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask19_7165_19775)'>
				<rect x='7.66992' y='6.07031' width='51.77' height='36.1' fill='#E5F2FF' />
			</g>
			<path
				d='M40.0497 21.6299L34.0497 25.1099L25.4297 20.1699C25.0797 19.9799 25.0497 19.6699 25.3397 19.5099C25.7053 19.3294 26.1341 19.3294 26.4997 19.5099L33.8397 23.7399L38.7797 20.8899C39.1521 20.7202 39.5833 20.7387 39.9397 20.9399C40.2697 21.1599 40.2997 21.4499 40.0497 21.6299Z'
				fill='#0000FF'
			/>
			<mask id='mask20_7165_19775' maskUnits='userSpaceOnUse' x='25' y='19' width='16' height='7'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M40.0497 21.6299L34.0497 25.1099L25.4297 20.1699C25.0797 19.9799 25.0497 19.6699 25.3397 19.5099C25.7053 19.3294 26.1341 19.3294 26.4997 19.5099L33.8397 23.7399L38.7797 20.8899C39.1521 20.7202 39.5833 20.7387 39.9397 20.9399C40.2697 21.1599 40.2997 21.4499 40.0497 21.6299Z'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask20_7165_19775)'>
				<rect x='19.5801' y='13.8301' width='26.17' height='16.82' fill='#0000FF' />
			</g>
		</svg>
	</Wrapper>
)
